import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "medal",
  "use": "medal-usage",
  "viewBox": "0 0 18.4 23.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.4 23.3\" id=\"medal\"><path d=\"M9.2 23.3l-.3-.2C-2.7 16.7.3 2.2.4 2.1l.1-.3.3-.1C4.8.1 8.4 0 9.1 0h.1c.7 0 4.3.1 8.4 1.7l.4.1v.3c0 .1 3 14.6-8.5 21l-.3.2zM1.4 2.6C1.1 4.6-.5 16.4 9.2 22c9.7-5.6 8.1-17.4 7.8-19.4-3.8-1.4-7.1-1.5-7.7-1.5h-.2c-.6 0-3.9.1-7.7 1.5zm12.5 14l-4.7-2.5-4.7 2.5.9-5.2-3.8-3.8 5.3-.8L9.3 2l2.4 4.8 5.3.8-4 3.7.9 5.3zm-4.7-3.8l3.2 1.7-.6-3.6 2.6-2.5-3.6-.5-1.6-3.3-1.6 3.3-3.6.5 2.6 2.5-.6 3.6 3.2-1.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol